export const environment = {
  production: true,
  baseUrl: 'https://testbtv.ru',
  beatmakerApiBaseUrl: 'https://api.testbtv.ru'
} as const
